export default "__VITE_ASSET__AqpAU20z__"